import { unionBy } from 'lodash';

import { transformClubLocations, sortClubLocations } from '../utils/mapping/clubLocations';

import {
    FETCH_CLUB_LOCATIONS,
    FETCH_CLUB_LOCATIONS_SUCCESS,
    ADD_CLUB_LOCATION_SUCCESS,
    SELECT_CLUB_LOCATION_SUCCESS,
    EDIT_CLUB_LOCATION_SUCCESS,
    EDIT_CLUB_FACILITY_SUCCESS,
    SELECT_FACILITY_SUCCESS,
    CLEAR_SELECTED_FACILITY,
    SAVE_COURT_TO_FACILITY_SUCCESS,
    UPDATE_COURT_SUCCESS,
    FETCH_CLUB_LOCATION_FACILITIES_SUCCESS,
    DELETE_LOCATION_SUCCESS,
    ARCHIVE_FACILITY_SUCCESS,
    FETCH_FACILITY_COURTS_SUCCESS,
    FETCH_CLUB_LOCATIONS_WITH_FACILITIES,
    FETCH_CLUB_LOCATIONS_WITH_FACILITIES_SUCCESS,
} from '../actions/club-location-actions';

const initialState = {
    locations: [],
    locationsWithFacilities: [],
    facilities: {},
    courts: {},
    selectedLocation: null,
    selectedFacility: null,
    loading: false,
    loaded: false,
    error: false,
    areLocationsWithFacilitiesLoaded: false,
};

function reducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_CLUB_LOCATIONS: {
            return {
                ...state,
                loading: true,
            };
        }
        case FETCH_CLUB_LOCATIONS_WITH_FACILITIES: {
            return {
                ...state,
                loading: true,
                areLocationsWithFacilitiesLoaded: false,
            };
        }
        case FETCH_CLUB_LOCATIONS_WITH_FACILITIES_SUCCESS: {
            return {
                ...state,
                locationsWithFacilities: sortClubLocations(action.payload),
                areLocationsWithFacilitiesLoaded: true,
            };
        }
        case FETCH_FACILITY_COURTS_SUCCESS: {
            return {
                ...state,
                courts: {
                    ...state.courts,
                    [action.payload.facilityId]: action.payload.courts,
                },
            };
        }

        case ARCHIVE_FACILITY_SUCCESS: {
            const facilitiesList = state.facilities[action.payload.clubLocationId];
            return {
                ...state,
                facilities: {
                    ...state.facilities,
                    [action.payload.clubLocationId]: facilitiesList.filter(({ id }) => id !== action.payload.facilityId),
                },
            };
        }

        case DELETE_LOCATION_SUCCESS: {
            const newLocations = state.locations.filter(location => location.id !== action.payload);
            return {
                ...state,
                locations: newLocations,
                selectedLocation: newLocations[0],
            };
        }

        case 'CLUB_LOCATIONS:TOGGLE_LOADING': {
            return {
                ...state,
                loading: !state.loading,
            };
        }

        case FETCH_CLUB_LOCATION_FACILITIES_SUCCESS: {
            return {
                ...state,
                facilities: {
                    ...state.facilities,
                    [action.payload.locationId]: action.payload.facilities,
                },
            };
        }

        case CLEAR_SELECTED_FACILITY: {
            return {
                ...state,
                selectedFacility: null,
            };
        }

        case SELECT_FACILITY_SUCCESS: {
            return {
                ...state,
                selectedFacility: action.payload,
            };
        }

        case FETCH_CLUB_LOCATIONS_SUCCESS: {
            const transformedLocations = transformClubLocations(action.payload);
            const primaryLocation = action.payload.find(({ locationType }) => locationType === 'primary');

            return {
                ...state,
                locations: transformedLocations,
                selectedLocation: primaryLocation || transformedLocations[0],
            };
        }

        case ADD_CLUB_LOCATION_SUCCESS: {
            const addedClubLocation = action.payload.find(a => state.locations.every(b => b.id !== a.id));

            return {
                ...state,
                locations: unionBy(state.locations, action.payload, 'id'),
                selectedLocation: addedClubLocation,
            };
        }

        case SELECT_CLUB_LOCATION_SUCCESS:
            return {
                ...state,
                selectedLocation: action.payload,
            };

        case EDIT_CLUB_LOCATION_SUCCESS: {
            return {
                ...state,
                locations: action.payload.newList,
                selectedLocation: action.payload.updatedSelected,
            };
        }

        case EDIT_CLUB_FACILITY_SUCCESS: {
            return {
                ...state,
                selectedFacility: { ...action.payload },
            };
        }

        case SAVE_COURT_TO_FACILITY_SUCCESS: {
            return {
                ...state,
                locations: state.locations.map(location => {
                    if (location.id === state.selectedLocation.id) {
                        location.facilities.map(facility => {
                            if (facility.id === state.selectedFacility.id) {
                                facility.courts = [...facility.courts, action.payload];
                            }
                            return facility;
                        });
                    }
                    return location;
                }),
                // selectedLocation: {
                //     ...state.selectedLocation,
                //     facilities: state.selectedLocation.facilities.map(facility => {
                //         if (facility.id === state.selectedFacility.id) {
                //             facility.courts = [...facility.courts, action.payload];
                //         }
                //         return facility;
                //     })
                // },
                selectedFacility: {
                    ...state.selectedFacility,
                    courts: [...state.selectedFacility.courts, action.payload],
                },
            };
        }

        case UPDATE_COURT_SUCCESS: {
            return {
                ...state,
                locations: state.locations.map(location => {
                    if (location.id === state.selectedLocation.id) {
                        location.facilities.map(facility => {
                            if (facility.id === state.selectedFacility.id) {
                                facility.courts.map(court => {
                                    if (court.id === action.payload.id) {
                                        return { ...action.payload };
                                    }
                                    return court;
                                });
                            }
                            return facility;
                        });
                    }
                    return location;
                }),
                selectedFacility: {
                    ...state.selectedFacility,
                    courts: state.selectedFacility.courts.map(court => {
                        if (court.id === action.payload.id) {
                            return { ...action.payload };
                        }
                        return court;
                    }),
                },
            };
        }

        default:
            return state;
    }
}

export default reducer;
